<template>
  <div v-if="isLoading" class="itr-loading">
    <div class="itr-loading__content">
      <div class="itr-loading__image">
        <div
          class="itr-loading__image-shader"
          :style="`bottom: ${progress}%;`"
        />
      </div>
      <div v-if="!infinite" class="itr-loading__label">{{ progress }} %</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ItrLoading',
    props: {
      infinite: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      progress: 0,
      isLoading: true,
    }),
    mounted() {
      document.body.classList.add('modal-is-open');

      this.interval = setInterval(() => {
        this.progress += 4;
        if (this.progress >= 100) {
          if (!this.infinite) {
            clearInterval(this.interval);
            this.isLoading = false;
          } else if (this.infinite) {
            this.progress = 0;
            this.isLoading = true;
          }
        }
      }, 100);
    },
    beforeUnmount() {
      document.body.classList.remove('modal-is-open');
    },
  };
</script>

<style lang="scss" scoped>
  .itr-loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 1.5rem;
      font-weight: 600;
      color: #585b60;
    }

    &__image {
      position: relative;
      overflow: hidden;
      background-position: 50% 50%;
      background-repeat: no-repeat;
      background-size: 100%;
      border-radius: 5px;
      width: 124px;
      height: 50px;
      background-image: url('https://itreconomics.com/wp-content/uploads/2022/12/ITR-Corporate-Logo-no-tag.png');
    }
    &__image-shader {
      background-color: rgb(255, 255, 255);
      position: absolute;
      bottom: 0%;
      left: 0px;
      right: 0px;
      height: 100%;
      opacity: 0.7;
    }
    &__label {
      padding-top: 1rem;
      font-size: 14px;
      font-weight: 400;
    }
  }
</style>
